export interface WordSpiderLeaderboardEntry {
  id: number;
  score: number;
  displayName: string | null;
  updatedAt?: string;
}

interface WordSpiderLeaderboardResponse {
  status: string;
  data: WordSpiderLeaderboardEntry[];
}

export async function fetchPersonalBest(seed: string): Promise<number> {
  const url = new URL("/high-scores/wordspider/best", window.location.origin);
  url.searchParams.set("seed", seed);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to load personal best (${response.status})`);
  const data = await response.json();
  if (!Number.isFinite(data.score)) throw new Error("Invalid personal best response");
  return data.score;
}

export async function fetchLeaderboard(
  seed: string,
  limit = 20,
): Promise<WordSpiderLeaderboardEntry[]> {
  const url = new URL("/high-scores/wordspider", window.location.origin);
  url.searchParams.set("seed", seed);
  url.searchParams.set("limit", String(limit));

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Failed to load leaderboard (${response.status})`);
  }

  const data = (await response.json()) as WordSpiderLeaderboardResponse;
  return data?.data || [];
}
